import { useQuery } from "@tanstack/react-query";
import { deleteContentBlockerTemplate } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Delete given content blocker template via RCB Service API.
 */ function useContentBlockerTemplateDelete(id) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.deleteContentBlocker(id), ({ signal })=>deleteContentBlockerTemplate({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                id: String(id)
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: String(id)?.trim().length > 0 && !isNaN(Number(id))
    });
}
export { useContentBlockerTemplateDelete };
